import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { Button } from "./Button.js";
import { Droplet } from "./Splash.js";
/**
 * Catches render/lifecycle errors in its subtree and shows a calm, branded
 * fallback instead of a blank white screen. Copy is passed in so
 * the boundary carries no i18n dependency; the host wraps it under its locale
 * provider. `onError` is where telemetry hooks in.
 */
export class ErrorBoundary extends Component {
    state = { crashed: false };
    static getDerivedStateFromError() {
        return { crashed: true };
    }
    componentDidCatch(error, info) {
        try {
            this.props.onError?.(error, info);
        }
        catch {
            // Telemetry must never mask the original error.
        }
    }
    render() {
        if (!this.state.crashed)
            return this.props.children;
        return (_jsxs("div", { className: "splash", role: "alert", children: [_jsx(Droplet, { size: 56 }), _jsx("h1", { style: { fontSize: 20, fontWeight: 700, margin: 0 }, children: this.props.title }), _jsx("p", { className: "muted", style: { maxWidth: "34ch", textAlign: "center" }, children: this.props.message }), _jsx(Button, { variant: "primary", onClick: this.props.onReload, children: this.props.reloadLabel })] }));
    }
}
//# sourceMappingURL=ErrorBoundary.js.map